// see http://vuejs-templates.github.io/webpack for documentation.
var path = require('path')

const system = 'platform'
const basePrefix = `/${system}/` // '/'、'/abc/'，不支持相对路径
const pathFilter = new RegExp(`^(?!\/?${system}($|\/.*))(?!\/?__webpack_hmr$)`)
const baseUrl = 'http://localhost:7010'
// const baseUrl = 'https://dev-archcore.ctron.com.cn'//中台数据

module.exports = {
  title: 'Archbox',
  basePrefix: basePrefix, // 项目前缀，字符串前后需要带上'/'符号，以下三处地方均有引用，main.js中router.base、dev-server动态访问、prod-build过程
  build: {
    env: require('./prod.env'), // 使用 config/prod.env.js 中定义的编译环境
    index: 'index.html', // 编译输入的 index.html 文件
    assetsImgDirectory: path.resolve(__dirname, '../src/assets/img'), // 静态资源图片根目录
    assetsRoot: path.resolve(__dirname, '../dist/'), // 编译输出的静态资源路径
    assetsSubDirectory: 'static', // 编译输出的二级目录
    assetsPublicPath: basePrefix, // 编译发布的根目录，可配置为资源服务器域名或 CDN 域名
    productionSourceMap: true, // 是否开启 cssSourceMap
    // Gzip off by default as many popular static hosts such as
    // Surge or Netlify already gzip all static assets for you.
    // Before setting to `true`, make sure to:
    // npm install --save-dev compression-webpack-plugin
    productionGzip: false, // 是否开启 gzip
    productionGzipExtensions: ['js', 'css'], // 需要使用 gzip 压缩的文件扩展名
    // Run the build command with an extra argument to
    // View the bundle analyzer report after build finishes:
    // `npm run build --report`
    // Set to `true` or `false` to always turn it on or off
    bundleAnalyzerReport: process.env.npm_config_report
  },
  dev: {
    env: require('./dev.env'),
    port: 7000,
    autoOpenBrowser: false,
    assetsSubDirectory: 'static',
    assetsPublicPath: basePrefix,
    proxyTable: {
      'localhost' : {
        filter: pathname => pathname && pathFilter.test(pathname),
        target: baseUrl,
        logLevel: 'debug',
        changeOrigin: true,
        ws: true
      }
    },
    // allowedHosts: [
    //   'http://127.0.0.1:7000'
    // ],
    // CSS Sourcemaps off by default because relative paths are "buggy"
    // with this option, according to the CSS-Loader README
    // (https://github.com/webpack/css-loader#sourcemaps)
    // In our experience, they generally work as expected,
    // just be aware of this issue when enabling this option.
    cssSourceMap: false
  }
}



// WEBPACK FOOTER //
// ./config/index.js